import { Session, forceReauth } from '/app/utils/auth';

export const authorization = axios => {
    axios.interceptors.request.use(requestConfig => {
        const token = Session.getToken();
        if (!token) return requestConfig;

        requestConfig.headers.set('Authorization', `Bearer ${token}`);

        return requestConfig;
    });
};

export const unauthorized = axios => {
    axios.interceptors.response.use(response => response, error => {
        const { response, config: requestConfig } = error;

        if (response && response.status === 401 && !['/me/detailed', '/me/preferences'].includes(requestConfig?.url)) {
            setTimeout(() => {
                forceReauth();
            }, 2000)
        }

        return Promise.reject(error);
    });
}
